import React from 'react';
import { connect } from 'react-redux';
import Settings from './Settings';
import { updateHeader } from '../../../actions/local';

import { selectUser } from '../../../selectors/user';
import Mixpanel from '../../../Mixpanel';
class UserParamsContainer extends React.Component {
  componentDidMount() {
    const { appId, eventId } = this.props.match.params;
    this.props.updateHeader({
      leftBtn: 'nav',
      rightBtn: null,
      rightBtn2: null
    });

    Mixpanel.track('view', {
      viewableType: 'user-settings',
      viewableId: null,
      appId: +appId,
      eventId: +eventId,
      userId: this.props.user ? this.props.user.id : null
    });
  }

  render() {
    if (!this.props.user) {
      return null;
    }

    const { t, theme, history, user } = this.props;
    const matchParams = this.props.match.params;
    return <Settings {...{ t, theme, history, matchParams, user }} />;
  }
}

const mapDispatchToProps = {
  updateHeader: updateHeader
};

const mapStateToProps = (state, ownProps) => {
  return {
    user: selectUser(state, ownProps)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserParamsContainer);
